class GetValidationErrorMessageHandler {
    handle(validation, serverErrors, key, index) {
        const item = this._getItem(validation, key, index);
        const serverError = this._getServerError(serverErrors, key, index);

        if (serverError) {
            return serverError;
        }

        if (!item || !item.$error) {
            return '';
        }

        const { $params } = item;

        for (const key in $params) {
            if (!item[key]) {
                return this.errors[key] || 'Something is wrong... 🤔';
            }
        }

        return 'Something is wrong... 🤔';
    }

    _getItem(validation, key, index) {
        if (isNaN(index)) {
            return validation[key];
        }

        return validation.$each[index][key];
    }

    _getServerError(serverErrors, key, index) {
        if (!isNaN(index)) {
            // @TODO
            return '';
        }

        if (serverErrors.length) {
            const errorItem = serverErrors.find(error => error.param === key);

            if (errorItem) {
                return errorItem.message;
            }
        }

        return '';
    }

    get errors() {
        return {
            required: 'Should not be empty!',
            minLength: 'It is too short!',
            isFormatValid: 'Wrong format!',
            email: 'Email address is not valid!',
            atLeastOneItem: 'Please add at least one item!',
            hasToBePositiveNumber: 'It has to be a number above 0!',
            maxElements: 'You have chosen too many elements!',
            isYearValid: 'Wrong value!',
            percentage: 'Should be between 0 and 100!',
            canNotBeNegative: 'It can not be negative number!'
        };
    }
}

export default GetValidationErrorMessageHandler;
